<script lang="ts">
  import Home from "./pages/Home.svelte";
  import Art from "./pages/Art.svelte";
  import { Route, Router } from "svelte-navigator";
</script>

<main>
  <Router>
    <Route path="/"><Home /></Route>
    <Route path="art/*">
      <Route path="/"><Art /></Route>
      <Route path="/:shortcode" let:params
        ><Art shortcode={params.shortcode} /></Route>
    </Route>
  </Router>
</main>
